module.exports = __webpack_public_path__ + "img/km_32.dcbdf544.jpeg";